export const showRoles = (roles) => {
  if ("Mitglied" in roles) {
    return "Mitglied";
  }
  if ("Admin" in roles) {
    return "Admin";
  }
  if ("Editor" in roles) {
    return "Editor";
  }
  return "Trainer";
};
